var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDesktopGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 28,
    viewBox: "0 0 95 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2517 27.9467L46.6568 0.0314026H52.1349L39.7298 27.9467H34.2517Z",
    fill: "#4BFFB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2198 27.9467L59.6249 0.0314026H65.103L52.6978 27.9467H47.2198Z",
    fill: "#4BFFB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4218 0.0313009L37.1599 4.87824L3.23129 11.3409L28.5978 23.2967L26.4966 27.9687L-5.85631e-07 14.571L-8.9632e-07 7.46328L39.4218 0.0313009Z",
    fill: "#4BFFB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.051 20.0654L26.4966 27.9687L22.2959 25.5179L28.1122 13.2796L33.6054 12.3102L30.051 20.0654Z",
    fill: "#4BFFB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4558 27.8204L73.1236 0.0313171L81.3322 0.0313167L95 27.8204L89.5068 27.8204L77.2279 2.61635L64.949 27.8204L59.4558 27.8204Z",
    fill: "#4BFFB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDesktopGreen);
export default __webpack_public_path__ + "static/media/logo-desktop-green.9712186b304e1afb503515d038a6ff76.svg";
export { ForwardRef as ReactComponent };